import { useState, useEffect } from "react";
import "./tags.css";

export default function KeywordTagsInput({ value = [], onChange, apiUrl }) {
  const [input, setInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  // 🔎 autocomplete API
  useEffect(() => {
    if (input.length < 2) {
      setSuggestions([]);
      return;
    }

    const fetchKeywords = async () => {
      try {
        const res = await fetch(`${apiUrl}/api/keyword/getByLabel?label=${input}`);
        const data = await res.json();
        setSuggestions(data.keywords || []);
      } catch (err) {
        console.error(err);
      }
    };

    const debounce = setTimeout(fetchKeywords, 300);
    return () => clearTimeout(debounce);
  }, [input]);

  // ➕ ajouter un tag
  const addTag = (label) => {
    const clean = label.trim().toLowerCase();

    if (!clean) return;
    if (value.find((k) => k.label === clean)) return;

    const newTags = [...value, { label: clean }];
    onChange(newTags);
    setInput("");
    setSuggestions([]);
    console.log(value);
  };

  // ❌ supprimer
  const removeTag = (label) => {
    const newTags = value.filter((k) => k.label !== label);
    onChange(newTags);
  };

  // ⌨️ Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag(input);
    }
  };

  return (
    <div className="tags-container">
      <div className="tags-input">
        {value.map((tag) => (
          <div key={tag.label} className="tag">
            {tag.label}
            <span onClick={() => removeTag(tag.label)}>✕</span>
          </div>
        ))}

        <input
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Ajouter un mot-clé..."
        />
      </div>

      {suggestions.length > 0 && (
        <div className="suggestions">
          {suggestions.map((s) => (
            <div
              key={s.idKeyword}
              className="suggestion"
              onClick={() => addTag(s.label)}
            >
              {s.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}